export default "/assets/images/CC-stats-graph-lg.6b3ae7c8ecab5f09.webp";